export const BonusStatus = {
    Declined: 'Declined',
    Active: 'Active',
    Pending: 'Pending',
    Expired: 'Expired',
    Lost: 'Lost',
    Redeemed: 'Redeemed',
    Waiting: 'Waiting',
    AwardedExternal: 'AwardedExternal',
} as const;

export type BonusStatus = typeof BonusStatus[keyof typeof BonusStatus];
